<template>
  <div
    v-if="isPanelOpen"
    ref="sidePanel"
    class="panel-right"
    :style="{ backgroundColor: $store.state.darkmode ? '#00163f' : '#ffffff' }"
  >
    <div class="panel-content">
      <h2>Regra fiscal por {{ isProductRule ? "Produto" : "NCM" }}</h2>
      <b-form @submit.prevent="submitNCMRuleForm">
        <b-row>
          <b-col cols="6">
            <b-form-group label="Nome" label-for="name">
              <b-form-input
                v-model="taxRule.name"
                placeholder="Insira o nome da Regra Fiscal"
                id="name"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6" v-if="!isProductRule">
            <b-form-group label="NCM do produto" label-for="ncmCode">
              <b-form-input
                v-model="taxRule.ncmCode"
                disabled
                id="ncmCode"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6" v-if="isProductRule">
            <b-form-group label="Produto" label-for="productCode">
              <b-form-input
                v-model="taxRule.productCode"
                disabled
                id="productCode"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group
              label="Natureza da Operação"
              label-for="operationNature"
            >
              <b-form-input
                v-model="taxRule.operationNature"
                id="operationNature"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- ICMS-ST Section -->
        <b-row>
          <b-col>
            <h4>ICMS por Substituição Tributária (ICMS-ST)</h4>
            <b-table
              :items="paginatedRulesIcms"
              :fields="icmsFields"
              striped
              bordered
              hover
              class="mt-3"
            ></b-table>

            <b-button
              variant="primary"
              size="sm"
              class="mt-3"
              @click="showFieldsIcms = !showFieldsIcms"
            >
              Adicionar Estado
            </b-button>

            <div v-if="showFieldsIcms" class="mt-3">
              <b-row>
                <b-col>
                  <b-form-group label="Estado" label-for="state">
                    <b-form-select
                      v-model="icmsSt.estadoId"
                      id="state"
                      :options="stateOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Alíq. do ICMS:" label-for="icmsAliquot">
                    <b-form-input
                      v-model="icmsSt.icmsAliquot"
                      id="icmsAliquot"
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Redução do ICMS:">
                    <b-form-input
                      v-model="icmsSt.icmsReduction"
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Redução do ICMS-ST:">
                    <b-form-input
                      v-model="icmsSt.icmsStReduction"
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="MVA:">
                    <b-form-input
                      v-model="icmsSt.mva"
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Alíq. do ICMS-ST">
                    <b-form-input
                      v-model="icmsSt.icmsStAliquot"
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-button
                    style="width: 100%;"
                    variant="primary"
                    size="sm"
                    class="mt-3"
                    @click="addICMSState"
                  >
                    Confirmar
                  </b-button>
                </b-col>
              </b-row>
            </div>

            <b-pagination
              v-model="currentPage"
              :total-rows="taxRule.icmsSts.length"
              :per-page="perPage"
              align="center"
              class="mt-2"
            ></b-pagination>
          </b-col>
        </b-row>

        <!-- FCP Section -->
        <b-row>
          <b-col>
            <h4>Fundo de Combate à Pobreza (FCP)</h4>
            <b-table
              :items="paginatedRulesFcp"
              :fields="fcpFields"
              striped
              bordered
              hover
              class="mt-3"
            ></b-table>
            <b-button
              variant="primary"
              size="sm"
              class="mt-3"
              @click="showFieldsFcp = !showFieldsFcp"
            >
              Adicionar Estado
            </b-button>

            <div v-if="showFieldsFcp" class="mt-3">
              <b-row>
                <b-col>
                  <b-form-group label="Estado" label-for="stateFcp">
                    <b-form-select
                      v-model="fcp.estadoId"
                      id="stateFcp"
                      :options="stateOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="FCP:">
                    <b-form-input
                      v-model="fcp.fcp"
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="FCP-ST:">
                    <b-form-input
                      v-model="fcp.fcpSt"
                      type="number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-button
                    style="width: 100%;"
                    variant="primary"
                    size="sm"
                    class="mt-3"
                    @click="addFCPState"
                  >
                    Confirmar
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="taxRule.fcps.length"
              :per-page="perPage"
              align="center"
              class="mt-2"
            ></b-pagination>
          </b-col>
        </b-row>

        <!-- PIS e COFINS -->
        <h4>PIS E COFINS</h4>
        <b-row>
          <b-col>
            <b-form-group
              label="Situação tributária PIS e COFINS"
              label-for="pisCofins"
            >
              <b-form-input
                v-model="taxRule.pisCofinsTaxSituation"
                id="pisCofins"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <b-form-group label="Alíquota do PIS" label-for="pisRate">
              <b-form-input
                v-model="taxRule.pisAliquot"
                id="pisRate"
                type="number"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Alíquota do COFINS" label-for="cofinsRate">
              <b-form-input
                v-model="taxRule.cofinsAliquot"
                id="cofinsRate"
                type="number"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Botões -->
        <b-row class="mt-4">
          <b-col class="text-right">
            <b-button variant="secondary" @click="cancelForm()"
              >Cancelar</b-button
            >
            <b-button variant="secondary" @click="confirmForm()" class="ml-2"
              >Adicionar</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidePanel",
  props: {
    isPanelOpen: Boolean,
    isProductRule: Boolean,
    product: Object,
    stateOptions: Array
  },
  data() {
    return {
      showFieldsIcms: false,
      showFieldsFcp: false,
      perPage: 4,
      currentPage: 1,
      taxRuleNcm: {
        id: 0,
        name: "",
        ncmCode: "",
        operationNature: null,
        icmsSts: [],
        fcps: [],
        pisCofinsTaxSituation: null,
        pisAliquot: null,
        cofinsAliquot: null,
        productId: null
      },
      taxRuleProduct: {
        id: 0,
        name: "",
        productCode: null,
        operationNature: null,
        icmsSts: [],
        fcps: [],
        pisCofinsTaxSituation: null,
        pisAliquot: null,
        cofinsAliquot: null
      },
      icmsSt: {
        id: 0,
        estadoId: null,
        estado: {
          id: null,
          name: ""
        },
        icmsAliquot: null,
        icmsReduction: null,
        icmsStReduction: null,
        mva: null,
        icmsStAliquot: null,
        taxRuleNcmId: null,
        taxRuleProductId: null
      },
      fcp: {
        id: 0,
        estadoId: 0,
        estado: {
          id: 0,
          name: ""
        },
        fcp: null,
        fcpSt: null,
        taxRuleNcmId: 0,
        taxRuleProductId: 0
      },
      icmsFields: [
        { key: "estado.name", label: "Estado" },
        { key: "icmsAliquot", label: "Aliq. do ICMS" },
        { key: "icmsReduction", label: "Redução do ICMS" },
        { key: "icmsStReduction", label: "Redução do ICMS-ST" },
        { key: "mva", label: "MVA" },
        { key: "icmsStAliquot", label: "Aliq. do ICMS-ST" }
      ],
      fcpFields: [
        { key: "estado.name", label: "Estado" },
        { key: "fcp", label: "FCP" },
        { key: "fcpSt", label: "FCP-ST" }
      ],
      taxRule: null
    };
  },
  computed: {
    paginatedRulesIcms() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.taxRule.icmsSts.slice(start, end);
    },
    paginatedRulesFcp() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.taxRule.fcps.slice(start, end);
    },
    panelBackgroundFcp() {
      return this.$store.state.darkmode ? "#222a42" : "#FFFFFF";
    },
    taxRule() {
      this.taxRuleProduct.productCode = this.product.name;
      this.taxRuleNcm.ncmCode = this.product.ncm;
      this.taxRuleNcm.productId = this.product.Id
      return this.isProductRule ? this.taxRuleProduct : this.taxRuleNcm;
    }
  },
  methods: {
    submitNCMRuleForm() {
      console.log("Regra cadastrada:", this.taxRule);
      alert("Regra cadastrada com sucesso!");
      this.resetForm();
    },
    cancelForm() {
      this.resetForm();
      this.$emit("close-sidepanel");
    },
    confirmForm() {
      this.$emit(
        this.isProductRule ? "tax-rule-product" : "tax-rule-ncm",
        this.taxRule
      );
      this.resetForm();
    },
    resetForm() {
      this.taxRuleNcm = {
        id: 0,
        name: "",
        ncmCode: "",
        operationNature: null,
        icmsSts: [],
        fcps: [],
        pisCofinsTaxSituation: null,
        pisAliquot: null,
        cofinsAliquot: null,
        productId: 0
      };
    },
    addICMSState() {
      this.icmsSt.estado = null;
      this.taxRule.icmsSts.push(this.icmsSt);
      this.showFieldsIcms = !this.showFieldsIcms;
    },
    addFCPState() {
      this.fcp.estado = null;
      this.taxRule.fcps.push(this.fcp);
      this.showFieldsFcp = !this.showFieldsFcp;
    }
  }
};
</script>

<style scoped>
.panel-right {
  position: fixed;
  top: 0;
  right: 0;
  width: 45vw;
  height: 100%;
  z-index: 1050;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.3);
  padding: 20px;
  overflow-y: auto;
}
.panel-content {
  position: relative;
}
button {
  margin-top: 10px;
}
body {
  transition: margin-right 0.9s ease;
  color: #ffffff !important;
}
.panel-right.show {
  margin-right: 300px;
}
</style>
